import { SearchInput } from '@/components/SearchInput';
import { useAuth } from '@/services/auth';
import { campaignsSearch } from '@/state/campaigns/state';
import { useRecoilState } from 'recoil';
import { useGetCampaigns } from '../../api';

export const Search = () => {
    const { isAnonymous } = useAuth();
    const { data } = useGetCampaigns(isAnonymous);

    const [search, setSearch] = useRecoilState(campaignsSearch);

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = e.currentTarget.value || '';
        setSearch(value);
    };

    const handleSearchClear = () => {
        setSearch('');
    };

    if (!data.length) {
        return null;
    }

    return (
        <SearchInput
            id="campaigns-search-textfield"
            placeholder="Search campaigns"
            search={search}
            onChange={handleSearchChange}
            onClear={handleSearchClear}
        />
    );
};
